import React from 'react'

import PropTypes from 'prop-types'

import { useT } from '@galo-monitor/i18n'
import { jobChecked } from '@galo-monitor/icons'
import { colors } from '@galo-monitor/styles'
import Icon from '@galo-monitor/web-components/Icon'

import IconButton from '../IconButton'

const JobsIconButton = ({ iconColor, iconSize, ...props }) => {
  const t = useT()
  return (
    <IconButton tooltip={ t('job', { howMany: 2 }) } { ...props }>
      <Icon icon={ jobChecked } color={ iconColor } size={ iconSize } />
    </IconButton>
  )
}

JobsIconButton.propTypes = {
  iconColor: PropTypes.string,
  iconSize: PropTypes.number
}

JobsIconButton.defaultProps = {
  iconColor: colors.mutedText,
  iconSize: undefined
}

export default JobsIconButton
